import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import Home from './views/Home.vue'

Vue.use(Router)
Vue.use(Meta)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/overview',
      name: 'Overview',
      component: () => import(/* webpackChunkName: "about" */ './views/Overview.vue')
    },
    {
      path: '/Contact',
      name: 'Contact',
      component: () => import(/* webpackChunkName: "about" */ './views/Contact.vue')
    },
    {
      path: '/management-team',
      name: 'ManagementTeam',
      component: () => import(/* webpackChunkName: "about" */ './views/ManagementTeam.vue')
    },
  ],
  // eslint-disable-next-line no-unused-vars
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
})

export default router